import { render, staticRenderFns } from "./ConvenioDetalhar.vue?vue&type=template&id=244196f2&"
import script from "./ConvenioDetalhar.vue?vue&type=script&lang=js&"
export * from "./ConvenioDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports